/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetApplicationsByOwner = require('../services/GetApplicationsByOwner');
var GetAllApplicationStatus = require('../../application-dashboard/services/GetAllApplicationStatus');
var GetAllApplicationTypes = require('../services/GetAllApplicationTypes');

var NonDepInternalMyApplicationsView = require('../views/NonDepInternalMyApplicationsView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetApplicationsByOwner(), GetAllApplicationStatus(), GetAllApplicationTypes()).done(function(
    applications,
    applicationStatuses,
    applicationTypes
  ) {
    NavUtils.navigate('nondep/dashboard/my-applications');
    Scaffold.content.show(
      new NonDepInternalMyApplicationsView({
        model: new Backbone.Model({
          applications: applications,
          applicationStatuses: applicationStatuses,
          applicationTypes: applicationTypes
        })
      })
    );
    NProgress.done();
  });
};
